module.exports = __webpack_public_path__ + "static/kerry-227350fb4ed650319228550fbf41b8b3.jpg";